import React, { useState, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "GlobalContext";
import VideoPlayer from "./VideoPlayer";

import playBtnSVG from "images/play.svg";

import {
  HeroWrapper,
  TitleContainer,
  Title,
  BigSubtitle,
  ImageContainer,
  Image,
  VideoBtnContainer,
  VideoLink,
  PlayBtn,
  Label,
  ScrollCue,
} from "./styles/HeroStyles";

const Hero = () => {
  const [showVideo, setShowVideo] = useState(false);

  const { heroData, currentLang } = useContext(GlobalContext);

  return useMemo(() => {
    const {
      titre1,
      titre2,
      labelLectureVideo,
      idVideo,
      image,
      loading,
      error,
    } = heroData;

    error && console.log("Navbar data loading error: ", error);

    return (
      <React.Fragment>
        {showVideo && idVideo ? (
          <VideoPlayer videoId={idVideo} setShowVideo={setShowVideo} />
        ) : (
          <HeroWrapper className="hero">
            <TitleContainer className={BigSubtitle ? "right" : ""}>
              {titre1 && <Title>{titre1}</Title>}
              {titre2 && <BigSubtitle>{titre2}</BigSubtitle>}
            </TitleContainer>
            <ImageContainer>
              {image && <Image src={image.sourceUrl} alt={image.altText} />}
              {labelLectureVideo && (
                <VideoBtnContainer>
                  <VideoLink
                    as="button"
                    type="button"
                    onClick={() => setShowVideo(true)}
                  >
                    <PlayBtn>
                      <img src={playBtnSVG} alt="" />
                    </PlayBtn>
                    <Label>{labelLectureVideo}</Label>
                  </VideoLink>
                </VideoBtnContainer>
              )}
            </ImageContainer>
            <ScrollCue
              type="button"
              onClick={() =>
                window.scrollTo({
                  top: window.innerHeight - 70,
                  behavior: "smooth",
                })
              }
            >
              {currentLang === "en" ? "Discover" : "Découvrir"}
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 5v14M6 13l6 6 6-6" />
              </svg>
            </ScrollCue>
          </HeroWrapper>
        )}
      </React.Fragment>
    );
  }, [heroData, showVideo, currentLang]);
};

Hero.propTypes = {
  titre1: PropTypes.string,
  titre2: PropTypes.string,
  labelLectureVideo: PropTypes.string,
  idVideo: PropTypes.string,
  image: PropTypes.shape({
    altText: PropTypes.string,
    sourceUrl: PropTypes.string,
  }),
  miniatureVideo: PropTypes.shape({
    altText: PropTypes.string,
    sourceUrl: PropTypes.string,
  }),
};

Hero.defaultProps = {
  titre1: null,
  titre2: null,
  labelLectureVideo: null,
  idVideo: null,
  image: {
    altText: null,
    sourceUrl: null,
  },
  miniatureVideo: {
    altText: null,
    sourceUrl: null,
  },
};

export default Hero;
